import { api, ApiRequestConfig } from 'api';
import { LeadRequest, LeadRequestResponse } from './leads-types';

/**
 * Запрос на запись на консультацию
 * @param {LeadRequest} data
 * @param {string} regionId
 * @param {ApiRequestConfig} config
 * @returns {Promise<LeadRequestResponse>}
 */
export const sendRequestLead = (
  data: LeadRequest,
  regionId: string,
  { orchestratorHost, useCredentials, apiKey, requestID }: ApiRequestConfig
): Promise<LeadRequestResponse> =>
  api.post<LeadRequestResponse>(
    'send-lead',
    { ...data, regionId },
    { orchestratorHost, useCredentials, apiKey, requestID }
  );
